require('./components/navigation-mobile');
require('./components/languageswitcher');
require('./components/faq');
require('./components/facetwp');
require('./components/logo-slider');
